import LineChart from "../../components/LineChart";
import Header from "../../components/Header";
import { Box } from "@mui/material";

const Index = () => {
  return (
    <Box m="20px" sx={{ marginTop: "100px" }}>
      <Header title="Line Chart" subtitle="Simple Line Chart" />
      <Box height={"75vh"}>
        <LineChart data={[]} />
      </Box>
    </Box>
  );
};

export default Index;
